import SpongeUtils from "../plugins/global/SpongePlugin";

/**
 * Scene configeration object
 *
 * @export
 * @interface IBaseSceneConfig
 * @extends {Phaser.Types.Scenes.SettingsConfig}
 */
export interface BaseSceneConfig extends Phaser.Types.Scenes.SettingsConfig {
  key: string;
  active?: boolean;
}
/**
 *
 * @category scenes
 * @export
 * @class BaseScene
 * @extends {Phaser.Scene}
 */
export default class BaseScene extends Phaser.Scene {
  public sponge!: SpongeUtils;

  private preloadProgress: number = 0;
  private preloadVisual: Phaser.GameObjects.Graphics;
  private preloadText?: Phaser.GameObjects.Text;
  private _key: string;

  constructor(config: BaseSceneConfig) {
    super(config);
    this._key = config.key;
  }

  preload(): void {
    this.sponge = this.sys.plugins.get("sponge") as SpongeUtils; // cast

    console.log("BaseScene::preload");

    // a graphics element to track our load progress.
    this.preloadVisual = this.add.graphics();

    //as we are adding a font, only do it after our web-fonts have loaded
    if (this._key !== "Boot") {
      this.preloadText = this.add
        .text(
          this.cameras.main.centerX,
          this.cameras.main.height - 160,
          this.sponge.data.content.strings.loading,
          this.sponge.data.model.fonts.preloader
        )
        .setOrigin(0.5);
    }
    // Register a load progress event to show a load bar
    this.load.on("progress", (value: number) => {
      // console.log("LOAD PROGRESS", value);
      this.add.tween({
        targets: this,
        preloadProgress: value,
        duration: 200,
        onUpdate: () => {
          this.preloadVisual.clear();
          this.preloadVisual.fillStyle(0xff00ff, 1);

          // 'as number' - this counts as casting as game config accepts strings for these props.
          this.preloadVisual.fillRect(
            50,
            (this.sys.game.config.height as number) - 120,
            ((this.sys.game.config.width as number) - 100) *
              this.preloadProgress,
            60
          );
        },
      });
    });

    // Register a load complete event to launch the title screen when all files are loaded
    this.load.on("complete", () => {
      this.preloadVisual.destroy();
      if (this.preloadText) this.preloadText.destroy();
    });
  }

  update(time: number, delta: number): void {
    super.update(time, delta);
    if (this.preloadProgress < 1) {
    }
  }

  create(): void {
    // grab our utils

    if (!this.sponge) {
      this.sponge = this.sys.plugins.get("sponge") as SpongeUtils; // cast
    }

    // listen to events.
    // this.events.on("sleep", this.sleep, this);
    // this.events.on("wake", this.wake, this);
  }

  sleep(): void {
    // console.warn("BaseScene.wake called but nothing applied, please implement 'sleep' on " + this.constructor.name );
  }

  wake(): void {
    // console.warn("BaseScene.wake called but nothing applied, please implement 'sleep' on " + this.constructor.name );
  }

  shutdown(): void {
    // drop references to anything we have in create
    // delete this.sponge;
  }
}
